var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconYoutubeMobile = function SvgIconYoutubeMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M18.518 5.76a2.206 2.206 0 0 0-1.554-1.557c-1.37-.367-6.864-.367-6.864-.367s-5.491 0-6.864.367a2.206 2.206 0 0 0-1.553 1.558C1.316 7.134 1.316 10 1.316 10s0 2.866.367 4.24a2.206 2.206 0 0 0 1.553 1.557c1.373.367 6.864.367 6.864.367s5.495 0 6.864-.367a2.206 2.206 0 0 0 1.554-1.558c.366-1.373.366-4.239.366-4.239s0-2.866-.366-4.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.345 12.642 12.91 10 8.345 7.358v5.284Z"
  })));
};
export default SvgIconYoutubeMobile;